import { useSelector } from "react-redux";

import { MakerIcon } from "@/assets/icons";
import EmptyPlaceholder from "@/components/emptyPlaceholder";
import { Switch } from "@/components/ui/switch";
import Tooltip from "@/components/ui/tooltip";
import { useAppFeatures } from "@/hooks/useAppFeatures";
import { RootState } from "@/store";

import { AreaSummaryCard } from "./areaSummaryCard";

interface AdminAreaSelectedProps {
  overrideFilter?: boolean;
  onToggleOverrideFilter?: (value: boolean) => void;
  disableOverrideFilter?: boolean;
}

const AdminAreaSelected = ({
  overrideFilter,
  onToggleOverrideFilter,
  disableOverrideFilter
}: AdminAreaSelectedProps) => {
  const { isGlobalFilterEnabled, isAdminTreeEnabled } = useAppFeatures();
  const { adminAreaSettings, adminTreeSettings } = useSelector(
    (state: RootState) => state.spatial
  );

  const selectedCount = adminTreeSettings.selectedAreaIds.length;
  return (
    <AreaSummaryCard
      countryLabel={adminAreaSettings?.lv0?.label}
      isTreeEnabled={isAdminTreeEnabled}
      selectedAreaCount={selectedCount}
      adminAreaSettings={adminAreaSettings}
      header={
        isGlobalFilterEnabled && (
          <div className="flex justify-between items-center p-4 pb-0 border-gainsboro">
            <div>
              <div className="text-txtHeading font-semibold">
                Override Filter Area
              </div>
              <div className="text-txtBody">
                Enable to define another area input
              </div>
            </div>
            <Tooltip
              content="Can’t switch off. No filter area to refer to"
              position="top-center"
              disable={!disableOverrideFilter}
            >
              <div>
                <Switch
                  checked={overrideFilter}
                  onCheckedChange={onToggleOverrideFilter}
                  disabled={disableOverrideFilter}
                  data-testid="override-filter-switch"
                />
              </div>
            </Tooltip>
          </div>
        )
      }
      emptyState={
        <EmptyPlaceholder
          className="px-4 text-xs gap-3"
          icon={
            <MakerIcon className="fill-light-gray" width={32} height={32} />
          }
          description="No administrative area yet. Please select an area to continue."
        />
      }
    />
  );
};

export default AdminAreaSelected;
